import React from "react"

import Layout from "../components/layout"
import Snippet from "../components/snippet"

const Privacy = () => (
	<Layout
		meta={{
			title: "Aufnahme- und Datenschutzhinweise",
			description:
				"Accento is an amazing Java/JavaScript conference in Karlsruhe, Germany, on Sep 24th/25th 2019.",
			path: "/privacy",
		}}
	>
		<Snippet id="privacy-policy" />
	</Layout>
)

export default Privacy
